module.exports = __webpack_public_path__ + "static/media/whitePage.a17186ee.svg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/whitePage.svg
// module id = 334
// module chunks = 0